import React from "react";
import {Box} from '@mui/material';
import CustomAppBar from '../components/appbar';
import Prequalifications from "../components/Prequalifications";

const PrequalificationsPage = () => {
    return (
        <Box>
            <CustomAppBar active="prequalifications"/>
            <Prequalifications/>
        </Box>
    );
}

export default PrequalificationsPage;